import logo from './logo.svg';
import './App.css';
import Allrouts from './Pages/Allrouts';
import Navbar from './Components/Navbar';
import Footer from './Components/footer';
function App() {
  return (
    <div>
      <Navbar/>
      <Allrouts/>
      <Footer/>
    </div>
  );
}

export default App;
